import { render } from "./THticket.vue?vue&type=template&id=4fe8f83c&scoped=true"
import script from "./THticket.vue?vue&type=script&lang=js"
export * from "./THticket.vue?vue&type=script&lang=js"

import "./THticket.vue?vue&type=style&index=0&id=4fe8f83c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe8f83c"]])

export default __exports__